/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * log API Specification
 * OpenAPI spec version: 0.0.7
 */
import { useMutation, useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { computed, unref } from 'vue';
import type { MaybeRef } from 'vue';

import type {
  FilterResponse,
  GetV8LogAlertMessageByAlertRuleIdAndTargetIdParams,
  LogAlertMessageResponse,
  LogBaseResponse,
  LogContentRequest,
  LoggingHistoryV8Response,
  LoggingListV8Response,
  LoggingPreviousResponse,
  LoggingViewV8RequestBody,
  PostV8LogHistoryParams,
  PostV8LogListParams,
  PostV8LogParams,
  PreviousLoggingV8Request,
} from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType, BodyType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary getTargetLog
 */
export const postV8Log = (
  logContentRequest: MaybeRef<LogContentRequest>,
  params: MaybeRef<PostV8LogParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  logContentRequest = unref(logContentRequest);
  params = unref(params);

  return customAxiosInstance<LogBaseResponse>(
    {
      url: `/api/v8/log`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: logContentRequest,
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getPostV8LogMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV8Log>>,
    TError,
    { data: BodyType<LogContentRequest>; params: PostV8LogParams },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV8Log>>,
  TError,
  { data: BodyType<LogContentRequest>; params: PostV8LogParams },
  TContext
> => {
  const mutationKey = ['postV8Log'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV8Log>>,
    { data: BodyType<LogContentRequest>; params: PostV8LogParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return postV8Log(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV8LogMutationResult = NonNullable<Awaited<ReturnType<typeof postV8Log>>>;
export type PostV8LogMutationBody = BodyType<LogContentRequest>;
export type PostV8LogMutationError = ErrorType<unknown>;

/**
 * @summary getTargetLog
 */
export const usePostV8Log = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV8Log>>,
      TError,
      { data: BodyType<LogContentRequest>; params: PostV8LogParams },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV8Log>>,
  TError,
  { data: BodyType<LogContentRequest>; params: PostV8LogParams },
  TContext
> => {
  const mutationOptions = getPostV8LogMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary getLogAlertMessage
 */
export const getV8LogAlertMessageByAlertRuleIdAndTargetId = (
  alertRuleId: MaybeRef<string>,
  targetId: MaybeRef<string>,
  params?: MaybeRef<GetV8LogAlertMessageByAlertRuleIdAndTargetIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  alertRuleId = unref(alertRuleId);
  targetId = unref(targetId);
  params = unref(params);

  return customAxiosInstance<LogAlertMessageResponse>(
    {
      url: `/api/v8/log/alert/message/${alertRuleId}/${targetId}`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV8LogAlertMessageByAlertRuleIdAndTargetIdQueryKey = (
  alertRuleId?: MaybeRef<string>,
  targetId?: MaybeRef<string>,
  params?: MaybeRef<GetV8LogAlertMessageByAlertRuleIdAndTargetIdParams>,
) => {
  return [
    'api',
    'v8',
    'log',
    'alert',
    'message',
    alertRuleId,
    targetId,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV8LogAlertMessageByAlertRuleIdAndTargetIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV8LogAlertMessageByAlertRuleIdAndTargetId>>,
  TError = ErrorType<unknown>,
>(
  alertRuleId: MaybeRef<string>,
  targetId: MaybeRef<string>,
  params?: MaybeRef<GetV8LogAlertMessageByAlertRuleIdAndTargetIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV8LogAlertMessageByAlertRuleIdAndTargetId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV8LogAlertMessageByAlertRuleIdAndTargetIdQueryKey(
    alertRuleId,
    targetId,
    params,
  );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV8LogAlertMessageByAlertRuleIdAndTargetId>>
  > = ({ signal }) =>
    getV8LogAlertMessageByAlertRuleIdAndTargetId(
      alertRuleId,
      targetId,
      params,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!(unref(alertRuleId) && unref(targetId))),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV8LogAlertMessageByAlertRuleIdAndTargetId>>,
    TError,
    TData
  >;
};

export type GetV8LogAlertMessageByAlertRuleIdAndTargetIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV8LogAlertMessageByAlertRuleIdAndTargetId>>
>;
export type GetV8LogAlertMessageByAlertRuleIdAndTargetIdQueryError = ErrorType<unknown>;

/**
 * @summary getLogAlertMessage
 */

export function useGetV8LogAlertMessageByAlertRuleIdAndTargetId<
  TData = Awaited<ReturnType<typeof getV8LogAlertMessageByAlertRuleIdAndTargetId>>,
  TError = ErrorType<unknown>,
>(
  alertRuleId: MaybeRef<string>,
  targetId: MaybeRef<string>,
  params?: MaybeRef<GetV8LogAlertMessageByAlertRuleIdAndTargetIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV8LogAlertMessageByAlertRuleIdAndTargetId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV8LogAlertMessageByAlertRuleIdAndTargetIdQueryOptions(
    alertRuleId,
    targetId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary getPreviousLogging
 */
export const postV8LogDetailPrevious = (
  previousLoggingV8Request: MaybeRef<PreviousLoggingV8Request>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  previousLoggingV8Request = unref(previousLoggingV8Request);

  return customAxiosInstance<LoggingPreviousResponse>(
    {
      url: `/api/v8/log/detail/previous`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: previousLoggingV8Request,
      signal,
    },
    options,
  );
};

export const getPostV8LogDetailPreviousMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV8LogDetailPrevious>>,
    TError,
    { data: BodyType<PreviousLoggingV8Request> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV8LogDetailPrevious>>,
  TError,
  { data: BodyType<PreviousLoggingV8Request> },
  TContext
> => {
  const mutationKey = ['postV8LogDetailPrevious'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV8LogDetailPrevious>>,
    { data: BodyType<PreviousLoggingV8Request> }
  > = (props) => {
    const { data } = props ?? {};

    return postV8LogDetailPrevious(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV8LogDetailPreviousMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV8LogDetailPrevious>>
>;
export type PostV8LogDetailPreviousMutationBody = BodyType<PreviousLoggingV8Request>;
export type PostV8LogDetailPreviousMutationError = ErrorType<unknown>;

/**
 * @summary getPreviousLogging
 */
export const usePostV8LogDetailPrevious = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV8LogDetailPrevious>>,
      TError,
      { data: BodyType<PreviousLoggingV8Request> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV8LogDetailPrevious>>,
  TError,
  { data: BodyType<PreviousLoggingV8Request> },
  TContext
> => {
  const mutationOptions = getPostV8LogDetailPreviousMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary getLogFilters
 */
export const getV8LogFilters = (
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  return customAxiosInstance<FilterResponse>(
    { url: `/api/v8/log/filters`, method: 'GET', signal },
    options,
  );
};

export const getGetV8LogFiltersQueryKey = () => {
  return ['api', 'v8', 'log', 'filters'] as const;
};

export const getGetV8LogFiltersQueryOptions = <
  TData = Awaited<ReturnType<typeof getV8LogFilters>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV8LogFilters>>, TError, TData>>;
  request?: SecondParameter<typeof customAxiosInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV8LogFiltersQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV8LogFilters>>> = ({ signal }) =>
    getV8LogFilters(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV8LogFilters>>,
    TError,
    TData
  >;
};

export type GetV8LogFiltersQueryResult = NonNullable<Awaited<ReturnType<typeof getV8LogFilters>>>;
export type GetV8LogFiltersQueryError = ErrorType<unknown>;

/**
 * @summary getLogFilters
 */

export function useGetV8LogFilters<
  TData = Awaited<ReturnType<typeof getV8LogFilters>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV8LogFilters>>, TError, TData>>;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV8LogFiltersQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary getLogHistory
 */
export const postV8LogHistory = (
  loggingViewV8RequestBody: MaybeRef<LoggingViewV8RequestBody>,
  params: MaybeRef<PostV8LogHistoryParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  loggingViewV8RequestBody = unref(loggingViewV8RequestBody);
  params = unref(params);

  return customAxiosInstance<LoggingHistoryV8Response>(
    {
      url: `/api/v8/log/history`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: loggingViewV8RequestBody,
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getPostV8LogHistoryMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV8LogHistory>>,
    TError,
    { data: BodyType<LoggingViewV8RequestBody>; params: PostV8LogHistoryParams },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV8LogHistory>>,
  TError,
  { data: BodyType<LoggingViewV8RequestBody>; params: PostV8LogHistoryParams },
  TContext
> => {
  const mutationKey = ['postV8LogHistory'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV8LogHistory>>,
    { data: BodyType<LoggingViewV8RequestBody>; params: PostV8LogHistoryParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return postV8LogHistory(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV8LogHistoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV8LogHistory>>
>;
export type PostV8LogHistoryMutationBody = BodyType<LoggingViewV8RequestBody>;
export type PostV8LogHistoryMutationError = ErrorType<unknown>;

/**
 * @summary getLogHistory
 */
export const usePostV8LogHistory = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV8LogHistory>>,
      TError,
      { data: BodyType<LoggingViewV8RequestBody>; params: PostV8LogHistoryParams },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV8LogHistory>>,
  TError,
  { data: BodyType<LoggingViewV8RequestBody>; params: PostV8LogHistoryParams },
  TContext
> => {
  const mutationOptions = getPostV8LogHistoryMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary getLogList
 */
export const postV8LogList = (
  loggingViewV8RequestBody: MaybeRef<LoggingViewV8RequestBody>,
  params: MaybeRef<PostV8LogListParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  loggingViewV8RequestBody = unref(loggingViewV8RequestBody);
  params = unref(params);

  return customAxiosInstance<LoggingListV8Response>(
    {
      url: `/api/v8/log/list`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: loggingViewV8RequestBody,
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getPostV8LogListMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV8LogList>>,
    TError,
    { data: BodyType<LoggingViewV8RequestBody>; params: PostV8LogListParams },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV8LogList>>,
  TError,
  { data: BodyType<LoggingViewV8RequestBody>; params: PostV8LogListParams },
  TContext
> => {
  const mutationKey = ['postV8LogList'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV8LogList>>,
    { data: BodyType<LoggingViewV8RequestBody>; params: PostV8LogListParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return postV8LogList(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV8LogListMutationResult = NonNullable<Awaited<ReturnType<typeof postV8LogList>>>;
export type PostV8LogListMutationBody = BodyType<LoggingViewV8RequestBody>;
export type PostV8LogListMutationError = ErrorType<unknown>;

/**
 * @summary getLogList
 */
export const usePostV8LogList = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV8LogList>>,
      TError,
      { data: BodyType<LoggingViewV8RequestBody>; params: PostV8LogListParams },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV8LogList>>,
  TError,
  { data: BodyType<LoggingViewV8RequestBody>; params: PostV8LogListParams },
  TContext
> => {
  const mutationOptions = getPostV8LogListMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
